export default defineNuxtPlugin(async () => {
  const { account, setAccount } = useAuth()

  if (!account.value) await setAccount()
})
